import { Injectable } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { catchError, filter, map, Observable, of } from 'rxjs';
import { Permissions } from '../utils/permissions';

@Injectable({
  providedIn: 'root'
})
export class EditUserGuard {
  constructor(private authService: AuthService) {}

  canActivate(): Observable<boolean> {
    return this.authService.user$.pipe(
      filter((user) => !!user),
      map((user) =>
        Permissions['editUserInfo'].some((p) =>
          user!['https://advancedtech.com/roles']?.includes(p)
        )
      ),
      catchError(() => {
        return of(false);
      })
    );
  }
}
